<template>
  <div class="order">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
        <div class="space1"></div>
        <b-container>
            <b-row>
                <!-- v-if="orders.length === 0" -->
                
                <b-col v-if="orders.length === 0">
                  <div class="chip">
                    <div class="chip__icon">
                      <i
                        class="fa-regular fa-face-sad-tear"
                        style="color: Tomato"
                      ></i>
                    </div>
                    <p>ขออภัย ไม่มีรายการจองหนังสือ</p>
                    <div class="chip__close">
                      <!-- <ion-icon name="close"></ion-icon> -->
                    </div>
                 
                </div>
                </b-col>
            </b-row>
            <div class="card-columns">
                <div v-for="(item, index) of orders" :key="index">
                  <div
                    class="card card-order-list card-margin border-light shadow"
                    v-if="item.order_status != 5"
                  >
                    <div class="card-body">
                      <h5 class="card-title " v-if="item.order_status !== 4">
                        ออร์เดอร์ที่ {{ item.order_code }} 
                      </h5>
                       <h5 class="card-title text-danger" v-if="item.order_status === 4 && item.has_book_in_order === false">
                        ออร์เดอร์ที่ {{ item.order_code }} : ไม่พบหนังสือที่ทำการจอง
                      </h5>
                      <h5
                        class="card-title font-weight-bold text-primary"
                        v-if="item.order_status === 4"
                        v-show="item.has_book_in_order === true"
                      >
                        {{ item.order_code }} | รับที่ล็อกเกอร์
                        {{ item.locker_number }}
                      </h5>
                      <div class="card-content-more" v-if="!orderMore[item.order_id]">
                        <a
                          class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                          data-position="bottom"
                          data-delay="50"
                          data-tooltip="Add to favorites"
                          v-if="!orderMore[item.order_id]"
                          @click="orderShowMore(item.order_id)"
                        >
                          <i class="fas fa-ellipsis-v"></i>
                          <!-- <i class="fas fa-ellipsis-h"></i> -->
                          เพิ่มเติม</a
                        >
                        <!-- <img src="../../assets/loykrathong/gif-salyut-6.gif" alt="" class="firework-gif">
                         <img src="../../assets/loykrathong/gif-salyut-6.gif" alt="" class="firework-gif-1">
                        <img src="../../assets/loykrathong/krathong-item16.png" alt="" class="krathong-1"> -->
                        <!-- <img src="../../assets/halloween/kisspng-halloween-horror-jack-o-lantern-pumpkin-black-terror-pumpkin-5aaefda8c4f0d4.1282812215214176408067.png" alt="" class="pumkin"> -->
                      </div>
                      <div class="card-content-more" v-if="orderMore[item.order_id]">
                        <a
                          class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                          data-position="bottom"
                          data-delay="50"
                          data-tooltip="Add to favorites"
                          v-if="orderMore[item.order_id]"
                          @click="orderShowLess(item.order_id)"
                        >
                          <i class="fas fa-ellipsis-h"></i>
                        </a>
                      </div>
        
                      <div v-if="orderMore[item.order_id]">
                        <div
                          class="card-text"
                          v-for="(prod, j) of item.order_detail"
                          :key="j"
                        >
                          <h6 class="card-title" v-if="!readMore[prod.order_detail_id]">
                            <!-- https://www.myprincipallifestyle.com/assets/img/loading.gif -->
                            <!-- https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif -->
                            <img
                              src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                              alt=""
                              style="width: 20px; height: auto"
                              v-if="prod.trans_status === 0"
                            />
                            <!-- <i class="fas fa-spinner fa-sm" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                            <i
                              class="fas fa-check-circle fa-purple fa-sm"
                              v-if="prod.trans_status === 1"
                            ></i>
                            <i
                              class="far fa-times-circle fa-sm"
                              style="color: red"
                              v-if="prod.trans_status === 2"
                            ></i>
        
                            {{ prod.book_title.slice(0, 52) }}
                            <a
                              class=""
                              v-if="
                                !readMore[prod.order_detail_id] &&
                                  prod.book_title.length > 52
                              "
                              @click="showMore(prod.order_detail_id)"
                              >[...]</a
                            >
                          </h6>
        
                          <h6 class="card-title" v-if="readMore[prod.order_detail_id]">
                            <img
                              src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                              alt=""
                              style="width: 20px; height: auto"
                              v-if="prod.trans_status === 0"
                            />
                            <!-- <i class="fas fa-spinner" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                            <i
                              class="fas fa-check-circle fa-purple fa-sm"
                              v-if="prod.trans_status === 1"
                            ></i>
                            <i
                              class="far fa-times-circle fa-sm"
                              style="color: red"
                              v-if="prod.trans_status === 2"
                            ></i>
                            {{ prod.book_title }}
                            <a
                              class=""
                              v-if="readMore[prod.order_detail_id]"
                              @click="showLess(prod.order_detail_id)"
                            >
                              [ย่อ]</a
                            >
                          </h6>
                        </div>
                      </div>
        
                      <div class="card">
                        <div class="row">
                          <div class="col-md-12 mt-3">
                            <!-- <div class="card-content-more">
                                  <p class="locker-floating">001</p>
                                </div> -->
                            <!-- progressbar -->
                            <ul id="progressbar">
                              <li
                                class="active"
                                id="account"
                                v-if="
                                  item.order_status === 0 ||
                                    item.order_status === 1 ||
                                    item.order_status === 2 ||
                                    item.order_status == 3 ||
                                    item.order_status == 4 ||
                                    item.order_status == 5
                                "
                              >
                                <strong>รอยืนยัน</strong>
                              </li>
                              <li
                                id="personal"
                                class="active"
                                v-if="
                                  item.order_status === 1 ||
                                    item.order_status === 2 ||
                                    item.order_status === 3 ||
                                    item.order_status === 4 ||
                                    item.order_status === 5
                                "
                              >
                                <strong>ยืนยันรายการแล้ว</strong>
                              </li>
                              <li
                                id="personal"
                                v-if="
                                  item.order_status !== 1 &&
                                    item.order_status !== 2 &&
                                    item.order_status !== 3 &&
                                    item.order_status !== 4 &&
                                    item.order_status !== 5
                                "
                              >
                                <strong>ยืนยันรายการแล้ว</strong>
                              </li>
                              <li
                                id="search"
                                class="active"
                                v-if="
                                  item.order_status === 2 ||
                                    item.order_status === 3 ||
                                    item.order_status === 4 ||
                                    item.order_status === 5
                                "
                              >
                                <strong>กำลังค้นหาหนังสือ</strong>
                              </li>
                              <li
                                id="search"
                                v-if="
                                  item.order_status !== 2 &&
                                    item.order_status !== 3 &&
                                    item.order_status !== 4 &&
                                    item.order_status !== 5
                                "
                              >
                                <strong>กำลังค้นหาหนังสือ</strong>
                              </li>
                              <li
                                id="confirm"
                                class="active"
                                v-if="item.order_status === 3"
                              >
                                <strong>Packing</strong>
                              </li>
                              <li id="confirm" v-if="item.order_status !== 4">
                                <strong>รับหนังสือได้ที่ล็อกเกอร์</strong>
                              </li>
                              <li
                                id="confirm"
                                class="active"
                                v-if="
                                  item.order_status === 3 ||
                                    item.order_status === 4 ||
                                    item.order_status === 5
                                "
                                v-show="item.has_book_in_order === true"
                              >
                                <strong>รับหนังสือได้ที่ล็อกเกอร์ </strong>
                                <!-- <div class="card-content-more">
                                  <p class="locker-floating">ตู้ที่ 001</p>
                                </div> -->
                              </li>
                              <li
                                id="fail"
                                class="active"
                               v-if="
                                  item.order_status === 3 ||
                                    item.order_status === 4 ||
                                    item.order_status === 5
                                "
                               v-show="item.has_book_in_order === false"
                              >
                               
                               
                                <strong>ไม่พบหนังสือ</strong>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
        
                      <p class="card-text">
                        <small class="text-muted">
                          <i
                            class="fas fa-calendar-alt"
                            v-show="item.has_book_in_order === true"
                            >รับภายใน: {{ item.mustbeget_date | moment }}</i
                          >
                          <i v-if="item.order_status === 0">
                            <img
                              src="https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif"
                              alt=""
                              style="width: 15px; height: auto"
                            />
                            รอยืนยัน
                          </i>
                          <i v-if="item.order_status === 1">
                            <img
                              src="../../assets/icons/giphy.gif"
                              alt=""
                              style="width: 20px; height: auto"
                            />
                            ยืนยันรายการแล้ว
                          </i>
                          <i v-if="item.order_status === 2">
                            <img
                              src="../../assets/icons/inprogress.gif"
                              alt=""
                              style="width: 20px; height: auto"
                            />
                            กำลังค้นหาหนังสือ
                          </i>
        
                          <i v-if="item.order_status === 3">
                            <img
                              src="../../assets/icons/packing.gif"
                              alt=""
                              style="width: 25px; height: auto"
                            />
                            Packing
                          </i>
                          <i
                            v-if="item.order_status === 4"
                            v-show="item.has_book_in_order === true"
                          >
                            <img
                              src="../../assets/icons/locker.gif"
                              alt=""
                              style="width: 23px; height: auto"
                            />
                            รับหนังสือได้ที่ล็อกเกอร์
                          </i>
        
                          <i
                            v-show="item.has_book_in_order === false "
                            v-if="
                              item.order_status !== 4 ||
                                item.order_status !== 3 ||
                                item.order_status !== 2
                            "
                            class="fas fa-times-circle fa-sm"
                            style="color:red; font-size:15px;"
                          >
                          
                            <!-- <img
                              src="../../assets/icons/locker.gif"
                              alt=""
                              style="width: 23px; height: auto"
                            /> -->
                          <strong>ไม่พบหนังสือ</strong>  
                          </i>
                        </small>
                        <br />
                        <!-- <small class="text-muted">
                           <i
                            v-if="item.order_status === 4"
                            v-show="item.has_book_in_order === true"
                          >
                            <img
                              src="../../assets/icons/locker.gif"
                              alt=""
                              style="width: 23px; height: auto"
                            />
                            รับหนังสือได้ที่ล็อกเกอร์
                          </i>
                        </small>
                        <br> -->
                        <small class="text-muted">
                          <p class="text-danger">
                            **กรณีไม่มารับหนังสือ ระบบจะคิดค่าปรับ 5 บาทต่อเล่ม ต่อวัน
                            <!-- ** รับหนังสือได้ในวันที่ 18 เมษายน 2565 เป็นต้นไป [ สุขสันต์วันสงกรานต์ ครับ/ค่ะ] -->
                          </p>
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
        </b-container>
        <br/>
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import axios from "axios";
import moment from "moment";
export default {
  name: "order",
  components: { sidebar_user },
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      orders: [],
      readMore: {},
      show: false,
      orderMore: {},
      disable: false,
      setbooking: [],
      loggedIn: false,
      code: "",
      auth: [],
      time: null,
    };
  },

  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
  },
  filters: {
    moment: function(date) {
      moment.locale("th");
      return moment(date)
        .add(543, "year")
        .format("LL");
    },
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      // let tran = JSON.parse(localStorage.getItem("orders"));
      // console.log(tran);
    }
    if (localStorage.getItem("orders") == null) {
      this.getorder();
    } else {
      setInterval(() => {
        this.getorder_timeout();
      }, 5000);
    }

    if (localStorage.getItem("orders") != null) {
      this.loadOrder();
      this.show = true;
    }

    if (localStorage.getItem("booking") != null) {
      this.setbooking = JSON.parse(localStorage.getItem("booking"));
    }
  },
  methods: {
    moment: function() {
      return moment();
    },
    getorder() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          if (res.data.Orders !== null) {
            this.orders = res.data.Orders;
            if (localStorage.getItem("maxchk") != null) {
              // qty_borrow_max
              localStorage.setItem("maxchk", res.data.qty_borrow_max);
            }
            localStorage.setItem("orders", JSON.stringify(this.orders));

            this.show = true;
            this.$isLoading(false);
          }
        });
    },
    getorder_timeout() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      // this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          if (res.data.Orders !== null) {
            this.orders = res.data.Orders;
            // console.log(this.orders);
            if (localStorage.getItem("maxchk") != null) {
              // qty_borrow_max
              localStorage.setItem("maxchk", res.data.qty_borrow_max);
            }
            localStorage.setItem("orders", JSON.stringify(this.orders));

            this.show = true;
          }
        });
    },
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    orderShowMore(id) {
      this.$set(this.orderMore, id, true);
    },
    orderShowLess(id) {
      this.$set(this.orderMore, id, false);
    },
  },
};
</script>

<style lang="scss" scoped>

.home-section {
    position: relative;
    background: var(--greyLight-1);
    min-height: 100vh;
    top: 0;
    left: 78px;
    width: calc(100% - 78px);
    transition: all 0.5s ease;
    z-index: 2;
  }
  .sidebar.open ~ .home-section {
    left: 250px;
    width: calc(100% - 250px);
  }
  .home-section .text {
    display: inline-block;
    color: #11101d;
    font-size: 25px;
    font-weight: 500;
    margin: 18px;
  }
  /* */
  a {
    color: rgba(101, 101, 101, 0.961);
  }
  a:hover {
    text-decoration: initial;
    color: rgb(101, 101, 101);
  }
  .space {
    height: 300px;
  }
  .space1 {
    height: 50px;
  }
  .two {
    height: 1000px;
  }
  .text-muted i {
    margin: 0 5px;
  }
  /**/
  /*card*/

.card-body{
    font-family: "Kanit", sans-serif;
  }
  .card-margin {
    margin-bottom: 1.875rem;
  }
  .card-order-list {
    padding: 5px;
  }
  .card-margin-orderlist {
    margin-bottom: 1rem;
  }
  
  @media only screen and (max-width: 600px) {
    .card-timeline {
      background: chartreuse;
    }
  }
  @media (min-width: 768px) {
    .card-columns {
      column-count: 2;
    }
  }
  
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {
    .card-columns {
      column-count: 2;
    }
  }
  
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .card-columns {
      column-count: 2;
    }
  }
  .card-content-more {
    position: relative;
  }


.locker-floating {
    position: absolute;
    font-size: 12px;
    right: 40px;
    top: 80px;
    background-color: rgb(9, 113, 145);
    color: #fff;
    padding: 5px;
    font-family: "Kanit", sans-serif;
    border-radius: 20%;
    width: 30px;
    height: 30px;
  }
  .fa-purple {
    color: rgb(29, 172, 7);
  }
  .card-title {
    text-align: left;
    /* text-align: justify; */
    bottom: 10px;
  }
  .card-text {
    text-align: left;
    line-height: 23px;
    /* bottom: 5px; */
  }
  

  .card {
    border: 0px;
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
  }

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
  }
  
  /*end*/

  /* button */
  .btn-floating {
    position: absolute;
    /* bottom: 5px; */
    right: -8px;
    top: -49px;
    font-size: 10px;
  }
  
  /**/
  /* select*/

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
  }
  
  select.list-dt:focus {
    border-bottom: 2px solid #0099ff;
  }
  /**/
  /* progress*/

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
    margin-left: -39px;
  }
  
  #progressbar .active {
    color: var(--orange-color);;
  }
  
  #progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 25%;
    float: left;
    position: relative;
  }
  
  #progressbar #account:before {
    font-family: "Font Awesome 5 Free";
    content: "\f044";
  }
  
  #progressbar #personal:before {
     font-family: "Font Awesome 6 Free";
    content: "\f058";
    /* font-size: 20px; */
  }
  
  #progressbar #search:before {
    font-family: "Font Awesome 6 Free";
    content: "\f583";
    /* font-weight: 400;  */
    /* background-image: url('../../assets/icons/spider-web.png');
    background-size:cover ; */
    
  }
  
  #progressbar #confirm:before {
    /* font-family: "Font Awesome 6 Free";
        font: var(--fa-font-solid);
            content: "\f466"; */
            /* text-align: center; */
            font-family: "Font Awesome 6 Free"; 
      font-weight: 400; 
      content: "\f584";
  
  }
  #progressbar #fail:before {
    font-family: "Font Awesome 6 Free";
    content: "\f119";
  }
  #progressbar li:before {
    width: 50px;
    height: 50px;
    line-height: 45px;
    display: block;
    font-size: 18px;
    color: var(--white);
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
  }
  
  #progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 25px;
    z-index: -1;
  }
  
  #progressbar li.active:before,
  #progressbar li.active:after {
    background: var(--orange-color);
  }
  #progressbar #fail.active:before,
  #progressbar #failactive:after {
    background: #ff0000;
  }
  #progressbar #confirm.active:before,
  #progressbar #confirmactive:after {
    background: #16ca52;
  }
  .radio-group {
    position: relative;
    margin-bottom: 25px;
  }
  
  .radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
  }
  
  .radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
  }
  
  .radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  }
  
  .fit-image {
    width: 100%;
    object-fit: cover;
  }
  /**/

/*  CHIP  */
.chip {
  grid-column: 2 / 3;
  grid-row: 3 / 4;
  justify-self: center;
  width: 20rem;
  height: 4rem;
  border-radius: 1rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__icon {
    width: 3rem;
    height: 3rem;
    border-radius: 1rem;
    margin: 0 0 0 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
    color: var(--primary);
  }

  p {
    font-size: 1.1rem;
    margin-left: -1rem;
    color: #000;
    margin-top: 18px;
  }

  &__close {
    width: 1.6rem;
    height: 1.6rem;
    margin: 0 0.5rem;
    display: flex;
    font-size: 1.6rem;
    color: var(--greyLight-3);
    cursor: pointer;
  }
}
/**/
</style>
